import { required, email, requiredIf } from 'vuelidate/lib/validators'
import { isValidPhoneNumber } from 'libphonenumber-js'
import countries from '@/data/miscData/countries'

const formData = {
  'specialPatientName': {
    size: 8,
    type: 'text',
    name: 'specialPatientName',
    placeholder: 'Nome do paciente',
    value: null,
    hasIcon: true,
    icon: 'name',
    class: 'modal-form__item--50'
  },

  'specialPatientEmail': {
    size: 4,
    type: 'text',
    name: 'specialPatientEmail',
    placeholder: 'Endereço de e-mail',
    value: null,
    hasIcon: true,
    icon: 'email',
    class: 'modal-form__item--50'
  },

  'specialPatientDdiContactPhone': {
    size: 4,
    type: 'select',
    name: 'specialPatientDdiContactPhone',
    mask: ['(##) ####-####', '(##) #####-####'],
    placeholder: 'DDI',
    value: null,
    hasIcon: true,
    icon: 'telephone',
    class: 'modal-form__item--25',
    options: countries
  },

  'specialPatientContactPhone': {
    size: 4,
    type: 'text',
    name: 'specialPatientContactPhone',
    mask: ['(##) ####-####', '(##) #####-####'],
    placeholder: 'Telefone',
    value: null,
    hasIcon: false,
    class: 'modal-form__item--25'
  },

  'specialPatientGender': {
    size: 4,
    type: 'radio',
    name: 'specialPatientGender',
    radios: [
      {
        label: 'Feminino',
        value: 'F'
      },
      {
        label: 'Masculino',
        value: 'M'
      }
    ],
    value: null,
    hasIcon: true,
    icon: 'person',
    class: 'modal-form__item--50'
  },

  'specialPatientDateOfBirth': {
    size: 4,
    type: 'text',
    name: 'specialPatientDateOfBirth',
    mask: '##/##/####',
    placeholder: 'Data de nascimento',
    value: null,
    hasIcon: true,
    icon: 'birthday',
    class: 'modal-form__item--50'
  },

  'specialPatientCpf': {
    size: 4,
    type: 'text',
    name: 'specialPatientCpf',
    placeholder: 'CPF',
    mask: '###.###.###-##',
    value: null,
    errors: {
      isValidCpf: 'CPF inválido'
    },
    hasIcon: true,
    icon: 'cpf',
    class: 'modal-form__item--50'
  },

  'specialPatientRg': {
    size: 4,
    type: 'text',
    name: 'specialPatientRg',
    placeholder: 'RG',
    maxlength: 15,
    value: null,
    hasIcon: true,
    icon: 'rg',
    class: 'modal-form__item--50'
  },

  'specialPatientNationalHealthCard': {
    size: 4,
    type: 'text',
    name: 'specialPatientNationalHealthCard',
    mask: '######################',
    classes: ['flex-column', 'flex-nowrap'],
    placeholder: 'Cartão SUS',
    value: null,
    hasIcon: true,
    icon: 'sus',
    class: 'modal-form__item--50'
  },

  'addressCep': {
    size: 3,
    type: 'text',
    name: 'addressCep',
    placeholder: 'CEP',
    mask: '#####-###',
    value: null,
    hasIcon: true,
    icon: 'map',
    class: 'modal-form__item--30'
  },

  'addressStreet': {
    size: 6,
    type: 'text',
    name: 'addressStreet',
    placeholder: 'Rua',
    value: null,
    disabled: true,
    hasIcon: false,
    class: 'modal-form__item--30'
  },

  'addressNumber': {
    size: 3,
    type: 'text',
    name: 'addressNumber',
    placeholder: 'N.',
    value: null,
    hasIcon: false,
    class: 'modal-form__item--30'
  },

  'addressComplement': {
    size: 3,
    type: 'text',
    name: 'addressComplement',
    placeholder: 'Ap., conj.',
    value: null,
    hasIcon: true,
    icon: '',
    class: 'modal-form__item--30'
  },

  'addressDistrict': {
    size: 4,
    type: 'text',
    name: 'addressDistrict',
    placeholder: 'Bairro',
    value: null,
    disabled: true,
    hasIcon: false,
    icon: '',
    class: 'modal-form__item--30'
  },

  'addressCityName': {
    size: 3,
    type: 'text',
    name: 'addressCityName',
    placeholder: 'Cidade',
    value: null,
    disabled: true,
    hasIcon: false,
    class: 'modal-form__item--20'
  },

  'addressUfName': {
    size: 2,
    type: 'text',
    name: 'addressUfName',
    placeholder: 'UF',
    value: null,
    disabled: true,
    hasIcon: false,
    class: 'modal-form__item--10'
  },

  'addressLatitude': {
    type: 'hidden',
    hide: true,
    name: 'addressLatitude',
    value: null,
    hasIcon: false
  },

  'addressLongitude': {
    type: 'hidden',
    hide: true,
    name: 'addressLongitude',
    value: null,
    hasIcon: false
  }
}

const validations = {
  'specialPatientName': {
    value: {
      required
    }
  },

  'specialPatientEmail': {
    value: {
      email
    }
  },

  'specialPatientGender': {
    value: {
      required
    }
  },

  'specialPatientContactPhone': {
    value: {
      isValid (value) {
        if (value) {
          const iso = this.formData.specialPatientDdiContactPhone.value
          return isValidPhoneNumber(value, String(iso.toUpperCase()))
        }

        return true
      }
    }
  },

  'specialPatientCpf': {
    value: {
      isValidCpf (cpf) {
        return this.fn_VALID_CPF(cpf)
      }
    }
  },

  'specialPatientRg': {
    value: {
      isValid (value) {
        if (value) {
          const onlyDigits = value.replace(/\D/gi, '')
          return !/^[^1-9]+$/gi.test(onlyDigits)
        }

        return true
      }
    }
  },

  'specialPatientDateOfBirth': {
    value: {
      isValidDate (value) {
        if (value) {
          const date = this.$moment(value, 'DD/MM/YYYY', true)
          return date.isValid()
        }

        return true
      },

      isBeforeToday (value) {
        if (value) {
          const now = this.$moment()
          const walletValidity = this.$moment(value, 'DD/MM/YYYY', true)
          return walletValidity.isBefore(now, 'd')
        }

        return true
      }
    }
  },

  'addressCep': {
    value: {
      isValid (value) {
        if (value) {
          const regex = /(\d){5}-(\d){3}/
          return regex.test(value)
        }

        return true
      }
    }
  },

  'addressCityName': {
    value: {
      requiredIf (value) {
        if (this.formData['addressCep'].value) {
          return !!value
        }

        return true
      }
    }
  },

  'addressUfName': {
    value: {
      requiredIf (value) {
        if (this.formData['addressCep'].value) {
          return !!value
        }

        return true
      },

      isValid (value) {
        if (value && this.formData['addressCep'].value) {
          return !!this.UFS
            .map(uf => uf.name)
            .find(uf => uf === value.toUpperCase())
        }

        return true
      }
    }
  },

  'addressDistrict': {
    value: {
      requiredIf (value) {
        if (this.formData['addressCep'].value) {
          return !!value
        }

        return true
      }
    }
  },

  'addressStreet': {
    value: {
      requiredIf (value) {
        if (this.formData['addressCep'].value) {
          return !!value
        }

        return true
      }
    }
  },

  'addressNumber': {
    value: {
      requiredIf (value) {
        if (this.formData['addressCep'].value) {
          return !!value
        }

        return true
      }
    }
  }
}

export { formData, validations }
